import React, { useEffect, useState } from 'react';
import s from './CasosDeExito.module.css';
import "./CasosDeExito.module.css";
import Swiper from '../Swiper/Swiper';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import 'font-awesome/css/font-awesome.min.css';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

const modalStyles = {
    overlay: {
        zIndex: 1000,
        background: "#00000060",
        height: "100vh + 20px",
        marginTop: '-20px'
    },
    content: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "1rem"
    }
};

export default function CasosDeExito({data}) {
    const [modalCasos, setModalCasos] = useState(false);
    const [selected, setSelected] = useState({});

    useEffect(()=>{
        if(modalCasos){
            document.documentElement.style.overflowY = 'hidden';
        } else {
            document.documentElement.style.overflowY = 'unset';
        }
    },[modalCasos])

    const modalControl = function(){
        setModalCasos(true);
    }

    const formatHtml = function(){
        if(Object.keys(selected).length === 0) return "<></>";
        let aux = selected.cuerpo.replaceAll("<li>", "<li><i class='fa fa-thin fa-check'></i>");
        return aux;
    }

    if(!data.length){
        return (
            <header className={s.section}>
                <LoadingSpinner/>
            </header>
        )
    }

  return (
    <section className={s.section} id="CasosDeExito">
        <h3>Casos de éxito</h3>
        <Swiper modalControl={modalControl} setSelected={setSelected} data={data}/>

        <Modal
            isOpen={modalCasos}
            onRequestClose={()=>{setModalCasos(false)}}
            style={modalStyles}
            closeTimeoutMS={0}
            ariaHideApp={false}
            className="modalContainer"
        >
            <FontAwesomeIcon className={s.modalCloseIcon} icon={faXmark} color="#D9D9D9" onClick={()=>{setModalCasos(false);}}/>
            <img src={`http://peuma-ig.com.ar/admin/${selected.imagen}`} alt="Logo cliente" className={s.modalLogo}/>
            <div className={s.ulContainer} dangerouslySetInnerHTML={{ __html: formatHtml() }} />
            <button className={s.modalBtn} onClick={()=>{setModalCasos(false); window.scrollTo(0, document.getElementById("Contacto").offsetTop-120);}}>CONTACTANOS</button>
        </Modal>

    </section>
  )
}
